import { createSlice } from "@reduxjs/toolkit";
import { generateMonthlyReport } from "./MonthlyReport.thunk";

const baseState = {
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  reportData: null,
};

const initialState = {
  ...baseState,
};

export const monthlyReportSlice = createSlice({
  name: "monthlyReport",
  initialState,
  reducers: {
    // Reset actions
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateMonthlyReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(generateMonthlyReport.fulfilled, (state, action) => {
        state.reportData = action.payload;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(generateMonthlyReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error generating report";
      });
  },
});

export const { ResetStore } = monthlyReportSlice.actions;

export default monthlyReportSlice.reducer;

